import React from "react";

import "./need-help.scss";
import { useThemeContext } from "../../utils/theme-context";

const NeedHelp = () => {
	const { colorNeedHelpDark } = useThemeContext();

	const handleClick = () => {
		const overlay = document.createElement('div');
		overlay.style.cssText = `
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: rgba(0, 0, 0, 0.7);
			backdrop-filter: blur(5px);
			z-index: 9998;
		`;

		const modal = document.createElement('div');
		modal.style.cssText = `
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 9999;
		`;

		const closeBtn = document.createElement('button');
		closeBtn.innerHTML = '✕';
		closeBtn.style.cssText = `
			position: fixed;
			top: 30px;
			right: 30px;
			width: 50px;
			height: 50px;
			border: none;
			background-color: rgba(255, 255, 255, 0.2);
			color: white;
			border-radius: 50%;
			cursor: pointer;
			font-size: 28px;
			z-index: 10000;
			transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
			backdrop-filter: blur(10px);
			border: 1px solid rgba(255, 255, 255, 0.3);
			display: flex;
			align-items: center;
			justify-content: center;
		`;
		closeBtn.onmouseover = () => {
			closeBtn.style.backgroundColor = 'rgba(255, 255, 255, 0.3)';
			closeBtn.style.transform = 'scale(1.15) rotate(90deg)';
			closeBtn.style.boxShadow = '0 8px 32px rgba(0, 0, 0, 0.3)';
			closeBtn.style.borderColor = 'rgba(255, 255, 255, 0.5)';
		};
		closeBtn.onmouseout = () => {
			closeBtn.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
			closeBtn.style.transform = 'scale(1) rotate(0deg)';
			closeBtn.style.boxShadow = 'none';
			closeBtn.style.borderColor = 'rgba(255, 255, 255, 0.3)';
		};

		const closeModal = () => {
			overlay.style.opacity = '0';
			modal.style.opacity = '0';
			overlay.style.transition = 'opacity 0.4s ease-out';
			modal.style.transition = 'opacity 0.4s ease-out';
			setTimeout(() => {
				document.body.removeChild(overlay);
				document.body.removeChild(modal);
			}, 400);
		};

		closeBtn.onclick = closeModal;
		overlay.onclick = closeModal;

		const iframe = document.createElement('iframe');
		iframe.src = 'https://api.leadconnectorhq.com/widget/survey/fXRdOm9p3aM4iNGpHfOa?notrack=true';
		iframe.style.cssText = `
			width: 100%;
			height: 100%;
			border: none;
		`;
		iframe.allowFullscreen = true;

		modal.appendChild(iframe);
		modal.appendChild(closeBtn);
		document.body.appendChild(overlay);
		document.body.appendChild(modal);
	};

	return (
		<span className={colorNeedHelpDark ? `need-help dark` : `need-help light`}>
			<button id="egC3mNyH" onClick={handleClick}>
				Need help?
			</button>
		</span>
	);
};

export default NeedHelp;